import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
        '[Supabase] CRITICAL: Missing environment variables!\n' +
        `VITE_SUPABASE_URL: ${supabaseUrl ? 'SET' : 'MISSING'}\n` +
        `VITE_SUPABASE_ANON_KEY: ${supabaseAnonKey ? 'SET' : 'MISSING'}\n` +
        'These must be set as environment variables before building.'
    );
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
